import { Component, effect, inject, input } from '@angular/core';
import { UserEmploymentsStore } from './user-employments.store';
import { FilterBuilder } from '../../../helper/filter.builder';
import { EmploymentGridItemObject } from '@libs/types/src/user/object-type/employment-grid.object';
import { UserEmploymentDialogComponent } from '../user-employment-dialog/user-employment-dialog.component';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TableColumn, TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { getEmploymentsFrag } from './user-employments.query';
import { contentGlobalSuccess } from '../../../content.error';
import { isAllowed } from '../../../../shared/shared.global-service';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-user-employments',
    templateUrl: './user-employments.component.html',
    styleUrl: './user-employments.component.scss',
    providers: [UserEmploymentsStore],
    imports: [
        CardTableComponent,
        TranslatePipe,
        PrimeTemplate,
    ],
})
export class UserEmploymentsComponent {

    public readonly store = inject(UserEmploymentsStore);
    public readonly dialogService = inject(BaseDialogService);
    public readonly confirm = inject(ConfirmBuilder);

    public userId = input.required<string>();
    public canEdit = input(true);

    protected columns: TableColumn[] = [
        {
            name: 'dateFrom',
            type: TableColumnType.Date,
        },
        {
            name: 'dateTo',
            type: TableColumnType.Date,
        },
        {
            name: 'serviceName',
            dataKey: 'service',
        },
        {
            name: 'employmentTypeName',
        },
    ];

    constructor() {
        effect(() => this.refresh());
    }

    protected async employmentDetail(item?: EmploymentGridItemObject): Promise<void> {
        if (!this.canEdit()) return;
        this.dialogService.open(UserEmploymentDialogComponent, {
            maximizable: true,
            data: {
                userId: this.userId(),
                employment: item,
            },
        }).onClose.subscribe(() => this.refresh());
    }

    protected deleteEmployment(input: any): void {
        if (!this.canEdit()) return;
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteEmployment({ id: input.item.id });
                contentGlobalSuccess.next('common.deleted');
                await this.refresh();
            },
            input,
        );
    }

    private async refresh(): Promise<void> {
        await this.store.api.getEmployments(FilterBuilder.filter({
            userId: this.userId(),
            serviceId: this.store.globalGlobalStore.organizationStore.serviceIds(),
        }), getEmploymentsFrag);
    }

    protected readonly isAllowed = isAllowed;
}
